import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
const pulse = "xgccbuu-B";
export const styles = {
  base: {
    k1xSpc: "x1lliihq",
    kmuXW: "x2lah0s",
    ks0D6T: "x193iq5w",
    kWkggS: "xv573ff",
    kaIpWk: "x1d0dq8e",
    kKVMdj: "x1doqw8q x1aquc0h",
    k44tkh: "x1sbju2s",
    kyAemX: "x4hg4is",
    ko0y90: "xa4qsjk",
    $$css: true
  },
  circle: {
    kaIpWk: "xoy5co8",
    $$css: true
  }
};